export default __webpack_public_path__ + "static/media/3DS.a4f3ed74.svg";